var canvas, canvas2,text,fontSize, fontFamily, fSize, activeCOLOR, newText, zoom, cWidth = 1400, cHeight = 2000,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl,img,
    leftMarker, rightMarker, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", canvas, boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;


imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');



window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight
});

addModify(window['canvas2']);



$(document).ready(function() {

  baseImage = null; 

  function loadImage(url) {
    if (baseImage) {
      canvas2.remove(baseImage);
    }
    fabric.Image.fromURL(url, function(img) {
      img.set({
        left: halfWidth,
        top: halfHeight,
        selectable: false
      });
      // img.scale(.6);
      canvas2.add(img);
      baseImage = img; 
      img.sendToBack();
      // window['text1Page'].bringToFront();
      canvas2.renderAll();
    }, { crossOrigin: 'anonymous' });
  }

  var defaultUrl = $('#base1 img').attr('data-src');
  if(defaultUrl) {
    loadImage(defaultUrl);
  }

  
  // On style change
  jQuery(document).on('change', 'input[name="Style"]', function(e) {
    var selectedVal = $(this).val();

    if (selectedVal === 'Without Base (Height 9 Width 6 inches)') {
      var blackUrl = $('#base1 img').attr('data-src');
      loadImage(blackUrl);
    } else {
      var woodenUrl = $('#base2 img').attr('data-src');
      loadImage(woodenUrl);
    }
  });

});



const areaWidth = 1000;
const areaHeight = 1156;
const boardSize = 30;     // logical grid
const gapDefault = 6;     // minimum gap between tiles
const tileMax = 160;      // max tile size
const tileMin = 20;       // min tile size


let words = [];           // filled from your UI
let textureImg = null;    // set by your setTexture(url)
let crosswordGroup = null;
let currentBoard = null;
let lastBoardState = null;
let crosswordHistory = [];

// ✅ Initialize Texture
$(document).ready(function () {
  const defaultUrl = $('#shape_design a').first().find('img').attr('data-src');
  if (defaultUrl) {
    $('#shape_design img').first().addClass('active');
    setTexture(defaultUrl);
  }
});

// ✅ Handle Texture Change
$('#shape_design a').on('click', function (e) {
  e.preventDefault();
  const url = $(this).find('img').attr('data-src');
  $('#shape_design img').removeClass('active');
  $(this).find('img').addClass('active');
  setTexture(url);
});

// ✅ Load Texture
function setTexture(url) {
  fabric.Image.fromURL(
    url,
    function (img) {
      textureImg = img;

      // ✅ If crosswordGroup already exists — update all rects’ fills
      if (crosswordGroup && crosswordGroup._objects) {
        crosswordGroup._objects.forEach(obj => {
          if (obj.type === 'rect') {
            if (textureImg) {
              const tile = obj.width;
              const patternCanvas = document.createElement('canvas');
              patternCanvas.width = tile;
              patternCanvas.height = tile;
              const ctx = patternCanvas.getContext('2d');
              ctx.drawImage(
                textureImg.getElement(),
                0, 0,
                textureImg.getElement().naturalWidth || textureImg.width,
                textureImg.getElement().naturalHeight || textureImg.height,
                0, 0, tile, tile
              );
              obj.set('fill', new fabric.Pattern({ source: patternCanvas, repeat: 'no-repeat' }));
            } else {
              obj.set('fill', '#f7e2b0');
            }
          }
        });
        canvas2.renderAll();
      }

      // ✅ If no existing crossword yet, just load texture
      else if (currentBoard) {
        renderBoardOnCanvas(currentBoard);
      }
    },
    { crossOrigin: 'anonymous' }
  );
}


// ✅ Name Input Logic
const input = document.getElementById("nameInput");
const tagBox = document.getElementById("tagInputBox");
const nameCount = document.getElementById("nameCount");
const errorMsg = document.getElementById("errorMsg");

input.addEventListener("keydown", function (e) {
  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    const text = input.value.trim().toUpperCase();

    // Hide previous error
    errorMsg.style.display = "none";

    // ❌ Check for invalid characters
    if (text && !/^[A-Z]+$/.test(text)) {
      errorMsg.textContent = "Only letters (A–Z) are allowed — no numbers or symbols.";
      errorMsg.style.display = "block";
      input.value = "";
      return;
    }

    // ❌ Check for name limit
    if (words.length >= 10) {
      errorMsg.textContent = "You can only enter up to 10 names.";
      errorMsg.style.display = "block";
      input.value = "";
      return;
    }

    // ✅ Add valid name
    if (text && /^[A-Z]+$/.test(text)) {
      if (!words.includes(text)) {
        words.push(text);
        input.value = "";
        renderTags();
        buildScrabble();
      }
    }
  }
});

// ✅ Render Tags
function renderTags() {
  tagBox.querySelectorAll(".tag").forEach(tag => tag.remove());
  words.forEach((word, index) => {
    const tag = document.createElement("div");
    tag.className = "tag";
    tag.innerHTML = `${word} <span data-index="${index}">&times;</span>`;
    tagBox.insertBefore(tag, input);
  });
  nameCount.innerText = `${words.length}/10`;
}

tagBox.addEventListener("click", (e) => {
  if (e.target.matches(".tag span")) {
    const index = e.target.getAttribute("data-index");
    words.splice(index, 1);
    renderTags();
    buildScrabble();
  }
});

// ✅ Create Empty Board
function createBoard() {
  return Array.from({ length: boardSize }, () => Array(boardSize).fill(""));
}

// Check if word fits at computed start and doesn't conflict
function canPlace(board, word, row, col, direction, overlapIndex = 0) {
  const len = word.length;
  if (direction === "H") {
    const startCol = col - overlapIndex;
    if (startCol < 0 || startCol + len > boardSize) return false;
    for (let i = 0; i < len; i++) {
      const existing = board[row][startCol + i];
      if (existing !== "" && existing !== word[i]) return false;
    }
  } else {
    const startRow = row - overlapIndex;
    if (startRow < 0 || startRow + len > boardSize) return false;
    for (let i = 0; i < len; i++) {
      const existing = board[startRow + i][col];
      if (existing !== "" && existing !== word[i]) return false;
    }
  }
  return true;
}

function place(board, word, row, col, direction, overlapIndex = 0) {
  const len = word.length;
  if (direction === "H") {
    const startCol = col - overlapIndex;
    for (let i = 0; i < len; i++) board[row][startCol + i] = word[i];
  } else {
    const startRow = row - overlapIndex;
    for (let i = 0; i < len; i++) board[startRow + i][col] = word[i];
  }
}


// --- Fisher-Yates shuffle for randomness ---
function shuffle(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

// ✅ Build Crossword
function buildScrabble() {
  // ✅ Save only crossword group state for undo
  if (crosswordGroup) {
    crosswordHistory.push(JSON.stringify(crosswordGroup.toJSON(['left', 'top'])));
  }

  const board = createBoard();
  const shuffled = shuffle([...words]);
  const mid = Math.floor(boardSize / 2);

  function hasBadNeighbors(board, row, col, dir, word, matchIndex) {
    if (dir === "H") {
      let start = col - matchIndex;
      for (let i = 0; i < word.length; i++) {
        let cc = start + i;
        if (board[row][cc] !== "" && board[row][cc] !== word[i]) return true;
        if (row > 0 && board[row - 1][cc] !== "" && board[row][cc] === "") return true;
        if (row < boardSize - 1 && board[row + 1][cc] !== "" && board[row][cc] === "") return true;
      }
      if (start > 0 && board[row][start - 1] !== "") return true;
      if (start + word.length < boardSize && board[row][start + word.length] !== "") return true;
    } else {
      let start = row - matchIndex;
      for (let i = 0; i < word.length; i++) {
        let rr = start + i;
        if (board[rr][col] !== "" && board[rr][col] !== word[i]) return true;
        if (col > 0 && board[rr][col - 1] !== "" && board[rr][col] === "") return true;
        if (col < boardSize - 1 && board[rr][col + 1] !== "" && board[rr][col] === "") return true;
      }
      if (start > 0 && board[start - 1][col] !== "") return true;
      if (start + word.length < boardSize && board[start + word.length][col] !== "") return true;
    }
    return false;
  }

  function canPlace(board, word, row, col, dir, matchIndex) {
    if (dir === "H") {
      if (col - matchIndex < 0 || col - matchIndex + word.length > boardSize) return false;
    } else {
      if (row - matchIndex < 0 || row - matchIndex + word.length > boardSize) return false;
    }
    if (hasBadNeighbors(board, row, col, dir, word, matchIndex)) return false;
    return true;
  }

  function place(board, word, row, col, dir, matchIndex) {
    if (dir === "H") {
      let start = col - matchIndex;
      for (let i = 0; i < word.length; i++) board[row][start + i] = word[i];
    } else {
      let start = row - matchIndex;
      for (let i = 0; i < word.length; i++) board[start + i][col] = word[i];
    }
  }

  function cloneBoard(board) {
    return board.map(r => [...r]);
  }

  function tryPlaceWords(words, board) {
    if (words.length === 0) return board;
    let nextWord = words[0];
    let positions = [];
    for (let r = 0; r < boardSize; r++) {
      for (let c = 0; c < boardSize; c++) {
        if (board[r][c] !== "") positions.push([r, c]);
      }
    }
    shuffle(positions);

    for (let [r, c] of positions) {
      let idx = nextWord.indexOf(board[r][c]);
      while (idx !== -1) {
        for (let dir of shuffle(["H", "V"])) {
          if (canPlace(board, nextWord, r, c, dir, idx)) {
            let newBoard = cloneBoard(board);
            place(newBoard, nextWord, r, c, dir, idx);
            let result = tryPlaceWords(words.slice(1), newBoard);
            if (result) return result;
          }
        }
        idx = nextWord.indexOf(board[r][c], idx + 1);
      }
    }
    return null;
  }

  let finalBoard = null;
  for (let i = 0; i < shuffled.length && !finalBoard; i++) {
    let board0 = createBoard();
    let row = mid, col = mid;
    let first = shuffled[i];
    if (Math.random() < 0.5) {
      for (let k = 0; k < first.length; k++) board0[row][col + k] = first[k];
    } else {
      for (let k = 0; k < first.length; k++) board0[row + k][col] = first[k];
    }
    let remaining = shuffled.slice(0, i).concat(shuffled.slice(i + 1));
    finalBoard = tryPlaceWords(remaining, board0);
  }

  if (!finalBoard) return;
  renderBoardOnCanvas(finalBoard);
}

// ✅ Undo Scrabble (only last crossword layout)
$('#undoScrabbleBtn').on('click', function () {
  if (!crosswordHistory.length) {
    alert('No previous layout to undo.');
    return;
  }

  const last = crosswordHistory.pop();
  if (!last) return;

  if (crosswordGroup) {
    canvas2.remove(crosswordGroup);
  }

  fabric.util.enlivenObjects([JSON.parse(last)], function (objs) {
    crosswordGroup = objs[0];
    canvas2.add(crosswordGroup);
    canvas2.renderAll();
  });
});


// --- Button click ---
document.getElementById("buildScrabbleBtn").addEventListener("click", function () {
  buildScrabble();
});





// ----------------- RENDER (keeps background/text intact) -----------------
function renderBoardOnCanvas(board) {
  // Remove only previous crossword group (do not clear canvas)
  if (crosswordGroup) {
    canvas2.remove(crosswordGroup);
    crosswordGroup = null;
  }

  // collect filled cells to find bounding box
  const filled = [];
  for (let r = 0; r < boardSize; r++) {
    for (let c = 0; c < boardSize; c++) {
      if (board[r][c] !== "") filled.push([r, c]);
    }
  }
  if (filled.length === 0) {
    canvas2.renderAll();
    return;
  }

  const minR = Math.min(...filled.map(p => p[0]));
  const maxR = Math.max(...filled.map(p => p[0]));
  const minC = Math.min(...filled.map(p => p[1]));
  const maxC = Math.max(...filled.map(p => p[1]));

  const usedRows = maxR - minR + 1;
  const usedCols = maxC - minC + 1;

  // compute dynamic tile size to fit the designated area (area is centered inside full canvas)
  const areaLeft = 700;   // halfWidth from your globals
  const areaTop  = 845;

  // compute tile size so the crossword fits inside areaWidth x areaHeight
  const tileByWidth = Math.floor((areaWidth - gapDefault * (usedCols - 1)) / usedCols);
  const tileByHeight = Math.floor((areaHeight - gapDefault * (usedRows - 1)) / usedRows);
  let tile = Math.max(tileMin, Math.min(tileMax, Math.min(tileByWidth, tileByHeight)));
  let gap = gapDefault;

  // if calculated tile is too small, clamp and reduce gaps if needed
  if (tile < tileMin) {
    tile = tileMin;
    gap = Math.max(2, Math.floor((areaWidth - tile * usedCols) / Math.max(usedCols - 1, 1)));
  }

  const boardWidth = usedCols * tile + (usedCols - 1) * gap;
  const boardHeight = usedRows * tile + (usedRows - 1) * gap;

  // center the crossword inside the given area
  const groupLeft = 700;
  const groupTop  = 845;

  // build objects with coords relative to (0,0); we'll group them and position the group at groupLeft,groupTop
  const objs = [];

  for (let r = minR; r <= maxR; r++) {
    for (let c = minC; c <= maxC; c++) {
      const letter = board[r][c];
      if (!letter) continue;

      const localLeft = (c - minC) * (tile + gap);
      const localTop  = (r - minR) * (tile + gap);

      const rect = new fabric.Rect({
        left: localLeft,
        top: localTop,
        width: tile,
        height: tile,
        rx: Math.max(4, Math.round(tile * 0.08)),
        ry: Math.max(4, Math.round(tile * 0.08)),
        // stroke: "#b8860b",
        strokeWidth: Math.max(1, Math.round(tile * 0.04)),
        selectable: false,
        originX: 'left',
        originY: 'top'
      });

      // texture for each tile (stretched to tile size)
      if (textureImg) {
        const patternCanvas = document.createElement('canvas');
        patternCanvas.width = tile;
        patternCanvas.height = tile;
        const ctx = patternCanvas.getContext('2d');
        // draw texture scaled to tile size
        ctx.drawImage(textureImg.getElement(), 0, 0, textureImg.getElement().naturalWidth || textureImg.width, textureImg.getElement().naturalHeight || textureImg.height, 0, 0, tile, tile);
        const pattern = new fabric.Pattern({
          source: patternCanvas,
          repeat: 'no-repeat'
        });
        rect.set('fill', pattern);
      } else {
        rect.set('fill', '#f7e2b0');
      }

      const txt = new fabric.Text(letter, {
        left: localLeft + tile/2,
        top: localTop + tile/2,
        originX: 'center',
        originY: 'center',
        fontSize: Math.max(12, Math.round(tile * 0.62)),
        fontFamily: 'Markazi Text',
        fontWeight: 'bold',
        selectable: false,
        fill: '#3c2701'
      });

      objs.push(rect, txt);
    }
  }

  // create group and place at calculated left/top so it does not affect other layers
  crosswordGroup = new fabric.Group(objs, {
    left: groupLeft,
    top: groupTop,
    selectable: false
  });

  canvas2.add(crosswordGroup);

  // re-send background to back and bring user text objects to front
  try {
    if (currentImage) canvas2.sendToBack(currentImage);
  } catch(e) { /* ignore if not present */ }

  // bring known text objects (if exist) to front so they are visible above the crossword
  try {
    if (window['text1Page']) window['canvas2'].bringToFront(window['text1Page']);
    if (window['text2Page']) window['canvas2'].bringToFront(window['text2Page']);
  } catch(e) { /* ignore if not present */ }

  canvas2.renderAll();
}


// ✅ Ensure custom font loads before first crossword render
window.addEventListener("load", function () {
  Promise.all([
    document.fonts.load('400 16px "Markazi Text"'),
    document.fonts.load('700 16px "Markazi Text"'),
    document.fonts.ready
  ])
    .then(() => {
      // If you want to show a default grid or previous data, call buildScrabble() here:
      if (words.length > 0) buildScrabble();

      // ✅ Force one more render to fix text alignment
      setTimeout(() => {
        if (words.length > 0) buildScrabble();
      }, 200);
    })
    .catch(() => {
      // Fallback if font detection fails
      setTimeout(() => {
        if (words.length > 0) buildScrabble();
      }, 500);
    });
});

// function setTexture(url) {
//   fabric.Image.fromURL(url, function (img) {
//     textureImg = img;
//     buildScrabble();
//   }, { crossOrigin: 'anonymous' });
// }









window['text1Page'] = new fabric.Text('check',{
  left: 690,
  top: 1500,
  fontSize: 65,
  fontFamily: 'Kalam',
  fill: '#000',
  fontWeight: 'bolder',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

var fontName = window['text1Page'].fontFamily;
jQuery('.choose_font1').val("'" + fontName + "'").trigger('change');

// Add to canvas
window['canvas2'].add(window['text1Page']);

// Clear text on input focus if default
document.getElementById('text_1').addEventListener('focus', function () {
  if (window['text1Page'].text === 'Besties That Glow Together') {
    window['text1Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth(textObj, maxWidth) {
  let fontSize = 80; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_1').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text1Page'].set('text', newText);
  fitTextToWidth(window['text1Page'], 940);
  window['text1Page'].bringToFront();
  window['canvas2'].renderAll();
});




var maxWidth = 980;
var maxHeight = 150;

var para = "check" ;

window['text2Page'] = new fabric.Text(para,{
  left: 680,
  top: 1635,
  width: 980,
  fontSize: 55,
  fontFamily: 'Caveat',
  fontWeight: 'bolder',
  textAlign: 'center',
  isWrapping: true,
  fill: '#000'
});


var fontName = window['text2Page'].fontFamily;
jQuery('.choose_font2').val("'" + fontName + "'").trigger('change');

window['canvas2'].add(window['text2Page']);


var minFontSize = 20;
var maxFontSize = 55;

// Clear text on input focus if default
document.getElementById('text_2').addEventListener('focus', function () {
  if (window['text2Page'].text === 'Side by side or miles apart,\nour light stays the same.') {
    window['text2Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


// Helper: Adjust font size to fit both width and height
function autoFitText(textbox, maxW, maxH) {
  let fontSize = maxFontSize;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_2').addEventListener('input', function (e) {
  const input = e.target.value;
  window['text2Page'].set({
    text: input
  });
  fitTextToBox(window['text2Page'], maxWidth, maxHeight);
});

function fitTextToBox(textObj, maxWidth, maxHeight) {
  let fontSize = maxFontSize;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth || textObj.height > maxHeight;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}




function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

  // jQuery(window).on('load',function(){
  //   canvasBlock(canvas);
  //   loadFirstImg();
  // });

  jQuery(window).on('resize',function(){
    canvasBlock(canvas);
  });
}

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler(eventData,transform){
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}

initCropper();

function readURL2(input){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  if(cropper == ""){
  }else {
    cropper.destroy();
  }
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      jQuery('#blah').attr('src', e.target.result);
      reCroper.attr('data-img',e.target.result);
    };
    reader.readAsDataURL(input.files[0]);
    setTimeout(initCropper, 2500);
  }
}

function addImage(e,placeholderimg,canvas){
  var file = e.target.files[0];
  var reader = new FileReader();
  reader.onload = function(event){
    var imgObj = new Image();
    imgObj.src = event.target.result;
    imgObj.onload = function(){
      var img = new fabric.Image(imgObj);
      img.set({
        left: placeholderimg.left,
        top: placeholderimg.top,
        selectable:true,
        scaleX: placeholderimg.width / img.width,
        scaleY: placeholderimg.height / img.height,
      });
      canvas.add(img);
    };
  };
  reader.readAsDataURL(file);
}

function addCroppedImg(imgurl){
  canvas.remove(img).renderAll();
  fabric.Image.fromURL(imgurl, function(newImg){
    newImg.set({
      left: img.left,
      top: img.top,
      selectable: img.selectable
    });
    newImg.scaleToHeight(available_height);
    canvas.add(newImg).renderAll();
    img = newImg;
    canvas.renderAll();
  });
}

function initCropper(){
  var image = document.getElementById('blah');
  cropper = new Cropper(image, {
    viewMode: 1,
    dragMode: 'move',
    aspectRatio: sizeCrop,
    restore: false,
    guides: false,
    center: true,
    highlight: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    data:{}
  });
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').addClass('hidden');
  loader.addClass('hidden');
}

document.getElementById('crop_button').addEventListener('click', function(){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  var imgurl =  cropper.getCroppedCanvas().toDataURL();
  addCroppedImg(imgurl);
  setTimeout(function(){
    reCroper.parent().removeClass('hidden');
    jQuery('.popupImg').hide();
    loader.addClass('hidden');
    jQuery('#tadaWidget').removeClass('hidden');
  },500);
});

document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});

document.getElementById('reset_button').addEventListener('click', function(){
  cropper.reset();
});

document.getElementById('cancelCropper').addEventListener('click', function(){
  jQuery('.popupImg').hide();
  jQuery('#tadaWidget').removeClass('hidden');
});

jQuery(document).on('click','.btnReCrop', function(){
  loader.removeClass('hidden');
  imgurl = jQuery(this).attr('data-img');
  sizeCrop = jQuery(this).attr('data-ratio');
  img = window[jQuery(this).attr('data-obj')];
  canvas = window[jQuery(this).attr('data-canvas')];
  available_height = jQuery(this).attr('data-height');
  console.log(canvas);
  jQuery('#tadaWidget').addClass('hidden');
  setTimeout(function(){
    cropper.destroy();
    jQuery('#blah').attr('src',imgurl);
    initCropper();
    jQuery('.popupImg').show();
    loader.addClass('hidden');
  },150);
});

jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

jQuery(document).on('change','.fontFamily',function(){
  var fontID = jQuery(this).attr('data-canvas'),
      textOb = jQuery(this).attr('data-obj');
  canvas = window[fontID];
  activeOb = window[textOb];
  activeOb.set({ fontFamily: this.value });
  canvas.renderAll();
  fitTextToWidth(window['text1Page'], 940);
  fitTextToBox(window['text2Page'], maxWidth, maxHeight);
});


function loadColorPicker(colorBox){
  jQuery('#'+colorBox).colorpicker({
    inline: true,
    container: true,
    extensions:[{
      name: 'swatches',
      options:{
        colors:{
          'tetrad1': 'transparent',
          'tetrad2': '#e30405',
          'tetrad3': '#197b30',
          'tetrad4': '#0054a5',
          'tetrad5': '#ffcc00',
          'tetrad6': '#f6ebbe',
          'tetrad7': '#ffea00',
          'tetrad8': '#f8931d',
          'tetrad9': '#f499c2',
          'tetrad10': '#959595',
          'tetrad11': '#fef335',
          'tetrad12': '#a0400d',
          'tetrad13': '#000000',
          'tetrad14': '#604973',
          'tetrad15': '#afe8fc',
          'tetrad16': '#fffafa',
          'tetrad17': '#bc8cbe',
          'tetrad18': '#ff69b4',
          'tetrad19': '#93278f',
          'tetrad20': '#009987',
          'tetrad21': '#0af447',
          'tetrad22': '#00008b',
          'tetrad23': '#006400'
        },
        namesAsValues: false
      }
    }],
    template: '<div class="colorpicker">' +
      '<div class="colorpicker-saturation"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-hue"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-alpha">' +
      '   <div class="colorpicker-alpha-color"></div>' +
      '   <i class="colorpicker-guide"></i>' +
      '</div>' +
      '<div class="colorpicker-bar">' +
      '   <a href="javascript:void(0);" class="button btn-block colorOFF">Ok</a>'+
      '   <div class="ctn-icon-eyedropper dropper-eyedrop"><svg class="icon icon-eyedropper" viewBox="0 0 16 16">'+
      '   <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5'+
      '   0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207'+
      '   1.207 0 0 0 0-1.708zM2 12.707l7-7L10.293 7l-7 7H2z"/></svg></div>'+
      '</div>' +
      '</div>'
  }).on('colorpickerCreate', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('id'),
        active = colorBox.find('.currentColor'),
        activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
    },200);
  }).on('colorpickerChange', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('data-canvas'),
          textOb = colorBox.attr('data-obj'),
          active = colorBox.find('.currentColor'),
          activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
      colorBox.attr('data-color',activeCOLOR);
      canvas = window[colorID];
      activeOb = window[textOb];
      sCAle = activeOb.scaleX;
      activeOb.set('fill',activeCOLOR);
      activeOb.scaleX = .5;
      activeOb.setCoords();
      canvas.renderAll();
      activeOb.scaleX = sCAle;
      activeOb.setCoords();
      canvas.renderAll();
    },200);
  });
  jQuery(document).on('click','.colorBox',function(){
    jQuery('.colorBox').each(function(){
      jQuery(this).next().hide();
    });
    jQuery(this).next().show();
  });
  jQuery(document).on('click','.colorOFF',function(){
    var parENt = jQuery(this).parent().parent(),
        toolBarBox = parENt.parent().parent().parent().attr('id');
    if(toolBarBox === 'labelBase'){
      parENt.parent().parent().parent().parent().removeClass('active');
    }else{
      parENt.hide();
    }
  });
}

function updateFont(activeOb){
  if(activeOb){
    sCAle = activeOb.scaleX;
    activeOb.set('fontSize',fontSize);
    activeOb.set('fontFamily',fontFamily);
    activeOb.set('fill',activeCOLOR);
    activeOb.scaleX = .5;
    activeOb.setCoords();
    canvas.renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    canvas.renderAll();
  }
}

jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});




jQuery(window).on('load',function(){
  canvasBlock(canvas2);
  window['text1Page'].set('text','Besties That Glow Together');
  window['text2Page'].set('text','Side by side or miles apart,\nour light stays the same.');
  window['canvas2'].renderAll();
  // loadFirstImg();
});


function getCookie(name){
  let nameEQ = name + "=";
  let cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++){
    let cookie = cookies[i].trim();
    if(cookie.indexOf(nameEQ) === 0){
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

window.addEventListener("load", function(){
  if(getCookie("firstVisit")){
    console.log("✅ Cookie exists:", getCookie("firstVisit"));
  } else{
    console.log("❌ Cookie does not exist!");
    document.cookie = "firstVisit=textresizing; expires=" + new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString() + "; path=/;";
    location.reload();
  }
});



/* fetch Call */
// var size,thumbnail;
var loadedObject,tagValue,Texture,enterTitle,Font1,enterText,Font2,additionalInfo,frameColor, wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    resizeObjects(window['canvas2']);
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 350;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    canvas.remove(baseImage);
    window['canvas2'] = canvas.toDataURL('image/png');
    tagValue = jQuery('#tagInputBox .tag').map(function() {return jQuery(this).clone().children('span').remove().end().text().trim();}).get().join(', ');
    Texture = jQuery('#shape_design img.active').attr('value');
    enterTitle = jQuery('.enter_title input').val();
    Font1 = jQuery('.choose_font1 option:selected').val();
    enterText = jQuery('.enter_text textarea').val();
    Font2 = jQuery('.choose_font2 option:selected').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    frameColor = jQuery('.frameColorBox').val();
    canvasBlock(canvas);
    console.log(window['canvas2']);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#tagValue').val(tagValue);
      jQuery('#Texture').val(Texture);
      jQuery('#enterTitle').val(enterTitle);
      jQuery('#Font1').val(Font1);
      jQuery('#enterText').val(enterText);
      jQuery('#Font2').val(Font2);
      jQuery('#addInfo').val(additionalInfo);
      jQuery('#selected_frameColor').val(frameColor);
      //console.log('Server response:', data);
      jQuery('.product-form__buttons .product-form__submit').trigger('click');
      handleUpload(fileInputs,previewId);
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});



function resizeObjects(canvas) {
  if (window['placeholderimg1']) window['placeholderimg1'].setCoords();
  if (window['text1Page']) window['text1Page'].setCoords();
  if (window['text2Page']) window['text2Page'].setCoords();
  if (typeof crosswordGroup !== 'undefined') crosswordGroup.setCoords();
  if (typeof img !== 'undefined') img.setCoords();
  if (typeof newImg !== 'undefined') newImg.setCoords();

  canvas.renderAll();

  // ✅ Include uploaded image correctly
  var designResiz = new fabric.Group([
    window['placeholderimg1'],
    window['text1Page'],
    window['text2Page'],
    crosswordGroup,
    window.currentMainImage, // main uploaded image
  ].filter(Boolean));

  designResiz.set({
    left: halfWidth,
    top: halfHeight,
    originX: 'center',
    originY: 'center'
  });

  // ✅ Scale whole group to desired width
  designResiz.scaleToWidth(1050);
  designResiz.setCoords();

  canvas.renderAll();
}



function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.remove(baseImage);
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}